module.exports = __webpack_public_path__ + "resources/img/img-manufacturing-fems-m-jp.5164978c554c3ef1ab3838f5c4302c23.png";